import React, { forwardRef } from 'react';
import MuiMenu, { MenuProps as MuiMenuProps } from '@mui/material/Menu';
import { BpDesignSystem } from '../../types';

export type MenuProps = BpDesignSystem.PropsWithChildren<MuiMenuProps & {}>;

export const Menu = forwardRef<HTMLDivElement, MenuProps>(({ dataTest, ...props }, ref) => (
  <MuiMenu data-test={dataTest} {...props} ref={ref} />
));
